import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=3c70fbb4&scoped=true&lang=pug"
import script from "./UserIcon.vue?vue&type=script&lang=js"
export * from "./UserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70fbb4",
  null
  
)

export default component.exports